import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // Available across the app
})
export class ConsoleLoggingHandlerService {
  constructor() {
    this.handleLogs();
  }

  public handleLogs() {

    const methods = ['log', 'warn', 'error', 'info', 'debug'];

    methods.forEach(method => {
      const originalMethod = console[method];
      let isLogging = false; // Flag to avoid recursion

      console[method] = (...args: any[]) => {
        // Prevent recursion by checking if we're already inside the overridden method
        if (isLogging) {
          return;
        }

        isLogging = true;

        // Filter logs related to ngx-extended-pdf-viewer
        const isFromNgxPdfViewer = args.some(arg =>
          typeof arg === 'string' && arg.includes('ngx-extended-pdf-viewer')
        );

        // Optionally log to the console
        if (!isFromNgxPdfViewer) {
          originalMethod.apply(console, args);
        }

        isLogging = false; // Reset the flag after logging
      };
    });
  }
}
